import httpManager from "@/app/shared/utils/httpManager";

/**
 *
 * @param {Object} channelId
 *
 * @return {Promise<Object>}
 */
export async function fetchMmLite(channelId) {
  const url = `/channels/channel-customer/${channelId}/mm-lite/`;

  const response = await httpManager.get(url);

  return response?.data;
}
